const BASE_ARTICLE_URL = 'https://support.wix.com/articles/id';
export const getArticleLink = (articleId, locale) => `${BASE_ARTICLE_URL}/${articleId}?locale=${locale}`;
//# sourceMappingURL=get-article-link.js.map